module.exports = __webpack_public_path__ + "static/media/Artboard3.89d0813e.png";